import React from 'react'
import { motion } from 'framer-motion';
import ResumeCard from './ResumeCard';

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* Education */}
      <div className='w-full lgl:w-1/2'>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2013 - 2024</p>
          <h2 className="text-3xl md:text-4xl font-bold">Education</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="BSc in Computer Science and Engineering"
            subTitle="Chittagong University of Engineering and Technology (2019 – 2024)"
            result="Bangladesh"
            des="Completed my BSc in CSE from CUET. Studied programming languages, data structures, algorithms, database management, computer networks, operating systems, and software engineering."
          />
          <ResumeCard
            title="Higher Secondary Certificate (HSC)"
            subTitle="Shaheed Smriti College (2016 – 2018)"
            result="5/5"
            des="Science background. Completed HSC with full GPA."
          />
          <ResumeCard
            title="Secondary School Certificate (SSC)"
            subTitle="Narikalbari High School (2013 – 2016)"
            result="5/5"
            des="Completed SSC with full GPA from Science group."
          />
        </div>
      </div>

      {/* Job Experience */}
      <div className='w-full lgl:w-1/2'>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2024 - PRESENT</p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Backend & Platform Engineer"
            subTitle="Fresh Finest — US-based E-commerce (Jul 2024 – Present)"
            result="Remote"
            des="Sole backend engineer for a multi-platform US e-commerce operation. Built and deployed four production systems: a rule-based dynamic repricing engine with competitor price monitoring; a warehouse management system covering full pick-pack-pallet workflow with real-time inventory tracking; multi-platform marketplace connectors (Amazon SP-API, Amazon Ads, Walmart, TikTok Shop, Temu, Etsy) with OAuth2 token lifecycle management; and full CI/CD infrastructure via GitHub Actions + Jenkins with Blue-Green deployments on AWS EC2, Docker, and NGINX."
          />
          <ResumeCard
            title="React Developer"
            subTitle="Tork (2 months)"
            result="Remote"
            des="Developed a mobile health application, responsible for integrating the database layer with the React-based frontend."
          />
        </div>
      </div>
    </motion.div>
  );
}

export default Education;